<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>MERCHANDISE REPORT</h4>
			</div>

			<div class="col-md-12">
				<el-card shadow="never" class="box-card col-md-12 mb-4" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop:'8px' }">
					<div slot="header" class="clearfix" v-if="false">
						<span><strong>MERCHANDISE REPORT</strong></span>
					</div>
					<div>
						<div class="mb-3">
							<el-tabs v-model="tabIndex" @tab-click="handleTabClick">
								<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
									<MerchandiseReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
								</el-tab-pane>
							</el-tabs>
						</div>
					</div>
				</el-card>
			</div>
		</div>
	</div>
</template>

<script>
import Basic from '@/components/page/Basic.js'
import Footer from '@/views/Footer.vue'
import MerchandiseReportTab from '@/views/pages/MerchandiseReportTab.vue'

export default{
	extends: Basic,
	components:{
		MerchandiseReportTab,
	},
	data() {
		return {
			pldate: this.$route.query.pldate ? this.$route.query.pldate : null,
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			tabList:[
				{label:'Sales', name: 'merchandise', index: '0' },
			],
		}
	},
    mounted(){
		this.$emit('childrenRoute');
    },
    methods:{
        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },
	}
}

</script>
